import { render, staticRenderFns } from "./productsWeights.vue?vue&type=template&id=1a49a331&scoped=true&"
import script from "./productsWeights.vue?vue&type=script&lang=js&"
export * from "./productsWeights.vue?vue&type=script&lang=js&"
import style0 from "./productsWeights.vue?vue&type=style&index=0&id=1a49a331&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49a331",
  null
  
)

export default component.exports